import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';
import { ProductStore } from 'modules/product/stores';
import { BaasicDropdownViewStore } from 'common/stores';
import { ApplicationStore } from 'platform/application/stores';
import { RateCalculatorForm } from 'modules/rate-calculator/forms';
import { CarrierStore } from 'modules/carrier/stores';
import { RateServiceStore } from 'modules/rate/stores';
import { carrierTypes } from 'common/constants';
import { notificationError, isSeller } from 'core/utils';
import _ from 'lodash';

class RateCalculatorViewStore extends BaseViewStore {
	@observable carrierTypeRateGroups = [];

	form = new RateCalculatorForm({
		onSuccess: async () => {
			await this.getRates();
		},
	});

	constructor(props) {
		super(props);
		this.initialize();
	}

	@action.bound
	initialize = () => {
		this.suspend();
		this.warehouseDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('warehouse'),
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				warehouseOnly: true,
				isOrganizationActive: true,
				includeOnlySellerWarehouses: isSeller(this.rootStore) ? true : false,
				sellerWarehousesOnlyOrganizationId: isSeller(this.rootStore)
					? this.rootStore.applicationStore.currentOrganization.id
					: null,
				embed: ['warehouseOrganizationInfo', 'warehouseOrganizationInfo.address'],
			},
			onChangeCallback: selectedValue => {
				this.form.$('shipFromZipCode').set('value', selectedValue.extra.warehouseOrganizationInfo.address.zipCode);
			},
		});
		this.productDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('product'),
			store: new ProductStore(this.rootStore),
			filterProperties: {
				embed: ['box'],
			},
			onChangeCallback: this.setDimensions,
			itemTemplate: {
				value: 'id',
				label: 'mainSku',
			},
		});
		this.carrierDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('carriers'),
			filterProperties: {
				excludeThirdPartyCarriers: true,
			},
			store: new CarrierStore(this.rootStore),
			isMulti: true,
		});
		this.rateServiceStore = new RateServiceStore(this.rootStore);
		this.resume();
	};

	@action.bound
	getRates = async () => {
		this.suspend();
		try {
			const values = this.form.values();
			const result = await this.rateServiceStore.fetchRates(this.createRequestBody(values));
			if (result.length > 0) {
				this.prepareData(result);
			} else {
				this.rootStore.notificationStore.error('RATECALCULATOR.NORATESFOUND');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};

	createRequestBody = values => {
		const { carriers, isResidentialRecipient, useThirdPartyAccounts, ...newValues } = values;
		return {
			...newValues,
			residentialRecipient: isResidentialRecipient,
			excludeThirdPartyCarriers: !useThirdPartyAccounts,
			carrierIds: _.map(carriers, selectedCarrier => {
				return selectedCarrier.value;
			}),
		};
	};

	prepareData = rateGroups => {
		this.carrierTypeRateGroups = [];
		_.each(rateGroups, rateGroup => {
			rateGroup.selectedAccount = observable(rateGroup.carrierRates[0]);
			rateGroup.selectedAccount.rates = observable(rateGroup.selectedAccount.rates);
			switch (rateGroup.carrierType) {
				case carrierTypes.fedex:
					rateGroup.className = 'rate-calc__logo--fed';
					break;
				case carrierTypes.ups:
					rateGroup.className = 'rate-calc__logo--ups';
					break;
				case carrierTypes.stamps:
					rateGroup.className = 'rate-calc__logo--stamps';
					break;
			}
			const accountOptions = _.map(rateGroup.carrierRates, (carrierRate, idx) => {
				return {
					label: carrierRate.carrierName,
					value: idx,
				};
			});
			rateGroup.dropdownStore = new BaasicDropdownViewStore({
				staticOptions: accountOptions,
				value: {
					label: rateGroup.selectedAccount.carrierName,
					value: 0,
					extra: rateGroup.selectedAccount,
				},
				onChangeCallback: selectedValue => {
					selectedValue.extra = rateGroup.carrierRates[selectedValue.value];
				},
			});
			this.carrierTypeRateGroups.push(observable(rateGroup));
		});
	};

	@action.bound
	setDimensions = selectedValue => {
		this.form.$('weight').set('value', selectedValue.extra.weight);
		if (selectedValue.extra.box != null) {
			const box = JSON.parse(selectedValue.extra.box.json);
			const dimensions = {
				lenght: box.boxLength,
				width: box.boxWidth,
				height: box.boxHeight,
			};
			this.form.update(dimensions);
		} else {
			const dimensions = {
				lenght: selectedValue.extra.lenght,
				width: selectedValue.extra.width,
				height: selectedValue.extra.lenght,
			};
			this.form.update(dimensions);
		}
	};

	onCheckboxChange = async field => {
		field.set('value', !field.value);
		if (field.name == 'useThirdPartyAccounts') {
			await this.carrierDropdownStore.updateFilter({
				excludeThirdPartyCarriers: !field.value,
				page: 1,
				rpp: 25,
			});
		}
	};
}

export default RateCalculatorViewStore;



// WEBPACK FOOTER //
// ./src/modules/rate-calculator/stores/RateCalculatorViewStore.js